/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { ERROR_UPDATE_COST_BASIS_METHOD } from 'state/taxes/TaxActions';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionError } from 'state/analytics/AnalyticsActions';

const FailedUpdateCostBasisLogic = createLogic({
  type: ERROR_UPDATE_COST_BASIS_METHOD,

  // eslint-disable-next-line no-unused-vars
  process({ action }, dispatch, done) {
    // dispatch user message
    const title = '';
    const message = 'An error occurred when updating your cost basis';
    dispatch(addToast(false, title, message));
    // dispatch analytics message
    dispatch(analyticsActionError('UpdateCostBasis'));

    done();
  }
});

export default FailedUpdateCostBasisLogic;
